import format from 'date-fns/format';
import { countryFormat } from '../const/formatDate';

export const convertToFormatDate = (date: string) => {
  if (date) {
    const convertedDate = new Date(date);
    return convertedDate.toLocaleDateString(countryFormat);
  } else return '';
};

export const convertToFormatTime = (date: string) => {
  if (date) {
    const convertedDate = new Date(date);
    return convertedDate.toLocaleTimeString(countryFormat, {
      hour: '2-digit',
      minute: '2-digit',
    });
  } else return '';
};

export const convertToFormatDateTime = (date: string) => {
  if (date) {
    const convertedDate = new Date(date);
    return convertedDate.toLocaleTimeString(countryFormat, {
      hour: '2-digit',
      minute: '2-digit',
      weekday: 'short',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
  } else return '';
};

export const getLocalISODate = (date: Date): string => {
  const isoDateTime = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return isoDateTime.toISOString();
};

export const isDateToday = (date: string) => {
  if (date) {
    const convertedDate = new Date(date);
    const today = new Date();

    return convertedDate.toLocaleDateString() === today.toLocaleDateString();
  } else return false;
};

export const timeAgo = (date: string) => {
  const dateObject = new Date(date);
  const seconds = Math.floor((+new Date() - +dateObject) / 1000);
  const years = seconds / 31536000;
  if (years > 1) {
    return `${Math.floor(years)} lat`;
  }
  const months = seconds / 2592000;
  if (months > 1) {
    return `${Math.floor(months)} mies.`;
  }
  const days = seconds / 86400;
  if (days > 1) {
    return `${Math.floor(days)} dni`;
  }
  const hours = seconds / 3600;
  if (hours > 1) {
    return `${Math.floor(hours)} godz.`;
  }
  const minutes = seconds / 60;
  if (minutes > 1) {
    return `${Math.floor(minutes)} min.`;
  }
  return `${Math.floor(seconds)} sek.`;
};

export const formatDate = (date: Date) => {
  return format(date, 'yyyyMMdd');
};

export const getFormattedDateRangeValue = (dateFrom: string, dateTo: string) => {
  return `${convertToFormatDate(dateFrom)} ${convertToFormatTime(dateFrom)}  - ${convertToFormatDate(
    dateTo,
  )} ${convertToFormatTime(dateTo)}`;
};
